import {Typography, useTheme} from '@mui/material';
import {Stack} from '@mui/system';
import {StyledCard} from 'presentation/components';
import React from 'react';
import {CardIllustrationProps} from './types';

function CardIllustration({
	description,
	illustration,
	title,
	customColorDescription,
	customBackgroundColor,
}: CardIllustrationProps) {
	const {colors} = useTheme();
	return (
		<StyledCard.Container
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
				pb: 0,
				backgroundColor: customBackgroundColor,
			}}>
			<Stack flex={1} pb={'16px'}>
				{title ? (
					<Typography variant="alertTitle" color={colors.brand.primary.blue}>
						{title}
					</Typography>
				) : null}
				<Typography
					variant="body2"
					color={customColorDescription ?? colors.light.text.secondary}>
					{description}
				</Typography>
			</Stack>
			<Stack alignSelf={'end'}>{illustration}</Stack>
		</StyledCard.Container>
	);
}

export default CardIllustration;
